import React, { useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import * as selector from '../../selectors/selectors';
import { pageTitles } from '../shared/constants';
import ConversationHistoryHeader from './conversation-history-header';
import ConversationHistoryPage from './conversation-history-page';
import MessageComposer from './message-composer';
import ChannelContactInfoComponent from './channel-contact-info.component';
import { ChannelAccountModel } from '../../models/channels/channels.model';

interface Props {
    CardData: any;
    IsMobileDevice: boolean;
    IsDisabled: boolean;
    ActiveCardIndex: number;
    BackHandler: () => void
    UnreadCount: number;
    scrollRef: React.MutableRefObject<any>;
    pathName: string;
    editorState?: any;
    activeCardIndex?: number;
    deviceHeight: number;
}

const ConverstionHistory = (props: Props) => {
    const dispatch = useDispatch()
    const DeviceHeight: number = useSelector(selector.deviceHeight);
    const ChannelAccounts: ChannelAccountModel[] = useSelector(selector.Channels)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    const [openForwordMessage, setOpenForwordMessage] = useState<boolean>(false)
    const [media, setMedia] = useState<any>()
    const [message, setMessage] = useState<string>("")
    const [showContactInfo, setShowContactInfo] = useState<boolean>(false)
    const [isMobileSchedule, setIsMobileSchedule] = useState<boolean>(false);
    const [scheduleDateTime, setScheduleDateTime] = useState<number>(-1);
    const [suggestionMessage, setSuggestionMessage] = useState<string>("")

    const openForwardMessage = (media, msg) => {
        setOpenForwordMessage(true)
        setMedia(media);
        setMessage(msg)
    }

    const handelContactInfomobile = (isConfim: boolean) => {
        setShowContactInfo(isConfim)
    }

    const SetIsMobileSchedule = (confirm: boolean) => {
        if (confirm) {
            setIsMobileSchedule(!isMobileSchedule)
        }
        else {
            setScheduleDateTime(-1)
        }
    }

    return (
        <div className='h-p-100 o-hidden'>
            {
                showContactInfo &&
                // <div className='w-40 p-absolute t-1 r-0' style={{ zIndex: 1 }}>
                <ChannelContactInfoComponent
                    CardTitle={pageTitles.CONTACT_INFO}
                    ActionsData={undefined}
                    OnlineStatus={props.CardData?.OnlineStatus}
                    Name={props.CardData?.Name}
                    ParticipantID={props.CardData?.ID}
                    PageName={ChannelAccounts?.find(x => x.ID === props.CardData?.AccountId)?.NickName || props.CardData?.Name.split('@')[1]}
                    CloseContactInfo={() => setShowContactInfo(false)} 
                    ChannelType={props.CardData?.Type}
                    />
                // </div>

            }
            {((IsMobileDevice && !showContactInfo) || !IsMobileDevice) &&
                <div className={`d-flex flex-direction  ${IsMobileDevice ? "h-p-100 p-fixed l-0 b-0 r-0 t-0" : "h-p-100"}`}>
                    <ConversationHistoryHeader
                        CardData={props.CardData}
                        ActiveCardIndex={props.ActiveCardIndex}
                        BackHandler={props.BackHandler}
                        HandelContactInfomobile={handelContactInfomobile}
                        ActionsData={[]}
                    />
                    <ConversationHistoryPage
                        activeCardIndex={props.ActiveCardIndex}
                        IsMobileDevice={props.IsMobileDevice}
                        pathName={props.pathName}
                        DeviceHeight={DeviceHeight}
                        scrollRef={props.scrollRef}
                        CardData={props.CardData}
                        OpenForwardMessage={openForwardMessage}
                        UnreadCount={props.UnreadCount}
                        ChannelType={props.CardData?.Type}
                        handleSendSuggestion={(message) => { setSuggestionMessage(message) }}
                    />
                    <div className={props.IsMobileDevice && isMobileSchedule ? "w-p-100 p-fixed b-0 mb-1" : ""} style={props.IsMobileDevice ? { zIndex: 99 } : {}}>
                        <MessageComposer
                            IsUnsubscribe={!!props.CardData?.IsUnsubscribed || !!props.CardData?.Contact?.IsUnsubscribed || false}
                            IsGroupChat={!!props.CardData.GroupChat ? true : false}
                            GroupChat={props.CardData?.GroupChat ? props.CardData?.GroupChat : null}
                            Limit={props.CardData?.IsUnsubscribed ? 0 : 1}
                            className={`w-fill`}
                            UniqId={uuid()}
                            PhoneNumbers={[props.CardData?.PhoneNumber]}
                            ContactIDs={props.CardData?.Contact?.ID ? [props.CardData?.Contact?.ID] : []}
                            UnsubscribedCount={props.CardData?.IsUnsubscribed ? 1 : 0}
                            BlockedCount={props.CardData?.IsBlocked ? 1 : 0}
                            IsDisabled={props.IsDisabled}
                            setIsMobileSchedule={SetIsMobileSchedule}
                            ScheduleDateTime={scheduleDateTime}

                            ChannelType={props.CardData?.Type}
                            ParticipantID={props.CardData?.ID}
                            ChannelAccountID={props.CardData?.AccountId}
                            ChannelStatus={props.CardData.Status}
                            UserName={props.CardData?.UserName}
                            UserTyping={props.CardData?.UserTyping}
                            TicketingStatus={props.CardData?.Ticket?.Status}
                            SuggestionMessage={suggestionMessage}
                        />
                    </div>
                </div>
            }
        </div>
    )
}

export default ConverstionHistory;